var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_23803)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 29.7461,
    cy: 27,
    r: 21,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_23803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0517 18.353H26.6868C24.2899 18.353 22.3398 20.303 22.3398 22.7V30.065C22.3398 32.4618 24.2899 34.4118 26.6868 34.4118H34.0518C36.4486 34.4118 38.3986 32.4618 38.3986 30.065V22.7C38.3986 20.303 36.4486 18.353 34.0517 18.353V18.353ZM37.4572 30.065C37.4572 31.9427 35.9295 33.4704 34.0517 33.4704H26.6868C24.809 33.4704 23.2813 31.9427 23.2813 30.065V22.7C23.2813 20.8222 24.809 19.2945 26.6868 19.2945H34.0518C35.9295 19.2945 37.4572 20.8222 37.4572 22.7V30.065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3636 21.9941C27.9424 21.9941 25.9727 23.9639 25.9727 26.3851C25.9727 28.8063 27.9424 30.776 30.3636 30.776C32.7848 30.776 34.7546 28.8063 34.7546 26.3851C34.7546 23.9639 32.7848 21.9941 30.3636 21.9941ZM30.3636 29.8346C28.4616 29.8346 26.9141 28.2872 26.9141 26.3851C26.9141 24.4831 28.4616 22.9356 30.3636 22.9356C32.2657 22.9356 33.8131 24.4831 33.8131 26.3851C33.8131 28.2872 32.2657 29.8346 30.3636 29.8346Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8619 20.4321C34.1464 20.4321 33.5645 21.0142 33.5645 21.7296C33.5645 22.4451 34.1464 23.0272 34.8619 23.0272C35.5774 23.0272 36.1595 22.4451 36.1595 21.7296C36.1595 21.0141 35.5774 20.4321 34.8619 20.4321ZM34.8619 22.0856C34.6657 22.0856 34.5059 21.9259 34.5059 21.7296C34.5059 21.5332 34.6657 21.3736 34.8619 21.3736C35.0583 21.3736 35.2181 21.5332 35.2181 21.7296C35.2181 21.9259 35.0583 22.0856 34.8619 22.0856Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_23803",
    x: 0.898438,
    y: 0.394531,
    width: 57.6953,
    height: 57.6953,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.24219
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.92383
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_23803"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_23803",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_23803"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0588,
    height: 16.0588,
    fill: "white",
    transform: "translate(22.3398 18.353)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.722845bedd04b76cbdd003871c005287.svg";
export { ForwardRef as ReactComponent };